import { useState } from 'react';
import { NoticeField } from '../components/notice-field';
import { ActionError } from '../components/states';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useI18n } from '../lib/i18n';
import { useApiMutation } from '../lib/query';

// Préavis propres au contrat (BA-079) : avant chaque échéance et avant la fin du contrat. Vide :
// réglage de la branche, sinon du cabinet (Paramètres).

export function NoticesCard({
  contractId,
  dueNoticeDays,
  renewalNoticeDays,
  editable,
}: {
  contractId: string;
  dueNoticeDays: number | null;
  renewalNoticeDays: number | null;
  editable: boolean;
}) {
  const t = useI18n().t;
  const [form, setForm] = useState({
    dueNoticeDays,
    renewalNoticeDays: renewalNoticeDays || null,
  });
  const [saved, setSaved] = useState(false);
  const save = useApiMutation<typeof form>('PATCH', `/v1/contracts/${contractId}`, {
    invalidate: [`/v1/contracts/${contractId}`],
    onSuccess: () => setSaved(true),
  });
  const set = (key: keyof typeof form) => (days: number | null) => {
    setSaved(false);
    setForm((f) => ({ ...f, [key]: days }));
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.portfolio.notices}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <fieldset disabled={!editable} className="grid gap-4 sm:grid-cols-2">
          <NoticeField
            label={t.settings.dueNoticeDays}
            none={t.portfolio.inheritNotice}
            value={form.dueNoticeDays}
            onChange={set('dueNoticeDays')}
          />
          <NoticeField
            label={t.settings.contractEndNoticeDays}
            none={t.portfolio.inheritNotice}
            value={form.renewalNoticeDays}
            onChange={set('renewalNoticeDays')}
          />
        </fieldset>
        {editable ? (
          <div className="flex flex-wrap items-center gap-3">
            <Button disabled={save.isPending} onClick={() => save.mutate(form)}>
              {t.portfolio.saveNotices}
            </Button>
            {saved ? (
              <span role="status" className="text-sm text-success">
                {t.common.saved}
              </span>
            ) : null}
            <ActionError error={save.error} />
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
